var CryptoJS = require("crypto-js");

function encrypt(msg, key) {
  return CryptoJS.AES.encrypt(msg, key).toString();
}

function decrypt(cipherText, key) {
  let message = CryptoJS.AES.decrypt(cipherText, key);
  return message.toString(CryptoJS.enc.Utf8);
}
// console.log("ldap-clientid-",
//   decrypt("U2FsdGVkX1/9XqAvDAu3anV3o+HKjp/IRvDzQ8j8eUCnQZEwVn3SRram/AMHTRoynaWhqVi7IUpssCT2e2K7hg==", "atms-2024"))
//ldap
// console.log(
//   "ldap-clientid-",
//   encrypt("yD58Q~vW-gDd1dhUY.-7yNZOcg17zYjcT0HMwa0r", "atms-2024")
// );

module.exports = {
  encrypt,
  decrypt,
};
